export default {
  logoClientsData: {
    es: [
      {
        url: '/assets/images/logos/logo-clients/bbva.svg',
        type: 'image',
        alt: 'logo bbva',
      },
      {
        url: '/assets/images/logos/logo-clients/lookiero.svg',
        type: 'image',
        alt: 'logo lookiero',
      },
      {
        url: '/assets/images/logos/logo-clients/telefonica.svg',
        type: 'image',
        alt: 'logo telefonica',
      },
      {
        url: '/assets/images/logos/logo-clients/bankinter.svg',
        type: 'image',
        alt: 'logo bankinter',
      },
      {
        url: '/assets/images/logos/logo-clients/santander.svg',
        type: 'image',
        alt: 'logo santander',
      },
      {
        url: '/assets/images/logos/logo-clients/orange-bank.svg',
        type: 'image',
        alt: 'logo orange bank',
      },
      {
        url: '/assets/images/logos/logo-clients/securitas.svg',
        type: 'image',
        alt: 'logo securitas',
      },
      {
        url: '/assets/images/logos/logo-clients/repsol.svg',
        type: 'image',
        alt: 'logo repsol',
      },
      {
        url: '/assets/images/logos/logo-clients/pelayo.svg',
        type: 'image',
        alt: 'logo pelayo',
      },
      {
        url: '/assets/images/logos/logo-clients/universia.svg',
        type: 'image',
        alt: 'logo universia',
      },
      {
        url: '/assets/images/logos/logo-clients/endesa.webp',
        type: 'image',
        alt: 'logo endesa',
      },
      {
        url: '/assets/images/logos/logo-clients/bankia.svg',
        type: 'image',
        alt: 'logo bankia',
      },
      {
        url: '/assets/images/logos/logo-clients/cecabank.svg',
        type: 'image',
        alt: 'logo cecabank',
      },
      {
        url: '/assets/images/logos/logo-clients/spotlight.webp',
        type: 'image',
        alt: 'logo spotlight',
      },
      {
        url: '/assets/images/logos/logo-clients/belcorp.svg',
        type: 'image',
        alt: 'logo belcorp',
      },
      {
        url: '/assets/images/logos/logo-clients/lefebvre.svg',
        type: 'image',
        alt: 'logo lefebvre',
      },
      {
        url: '/assets/images/logos/logo-clients/oh.svg',
        type: 'image',
        alt: 'logo oh',
      },
      {
        url: '/assets/images/logos/logo-clients/billionhands.svg',
        type: 'image',
        alt: 'logo billionhands',
      },
      {
        url: '/assets/images/logos/logo-clients/azteca.svg',
        type: 'image',
        alt: 'logo azteca',
      },
      {
        url: '/assets/images/logos/logo-clients/orange-x.webp',
        type: 'image',
        alt: 'logo orange-x',
      },
      {
        url: '/assets/images/logos/logo-clients/european-union.svg',
        type: 'image',
        alt: 'logo union europea',
      },
      {
        url: '/assets/images/logos/logo-clients/cepsa.svg',
        type: 'image',
        alt: 'logo cepsa',
      },
      {
        url: '/assets/images/logos/logo-clients/pagos-fx.webp',
        type: 'image',
        alt: 'logo pagos-fx',
      },
      {
        url: '/assets/images/logos/logo-clients/wegow.svg',
        type: 'image',
        alt: 'logo wegow',
      },
      {
        url: '/assets/images/logos/logo-clients/galderma.svg',
        type: 'image',
        alt: 'logo galderma',
      },
      {
        url: '/assets/images/logos/logo-clients/deceye.svg',
        type: 'image',
        alt: 'logo deceye',
      },
      {
        url: '/assets/images/logos/logo-clients/agile-spain.webp',
        type: 'image',
        alt: 'logo agile spain',
      },
      {
        url: '/assets/images/logos/logo-clients/generali.webp',
        type: 'image',
        alt: 'logo generali',
      },
      {
        url: '/assets/images/logos/logo-clients/idipaz.webp',
        type: 'image',
        alt: 'logo idipaz',
      },
      {
        url: '/assets/images/logos/logo-clients/mm.webp',
        type: 'image',
        alt: 'logo mm',
      },
      {
        url: '/assets/images/logos/logo-clients/rubio.webp',
        type: 'image',
        alt: 'logo rubio',
      },
      {
        url: '/assets/images/logos/logo-clients/BCP_Peru_logo.png',
        type: 'image',
        alt: 'logo BCP Peru',
      },
    ],
    en: [
      {
        url: '/assets/images/logos/logo-clients/bbva.svg',
        type: 'image',
        alt: 'logo bbva',
      },
      {
        url: '/assets/images/logos/logo-clients/lookiero.svg',
        type: 'image',
        alt: 'logo lookiero',
      },
      {
        url: '/assets/images/logos/logo-clients/telefonica.svg',
        type: 'image',
        alt: 'logo telefonica',
      },
      {
        url: '/assets/images/logos/logo-clients/bankinter.svg',
        type: 'image',
        alt: 'logo bankinter',
      },
      {
        url: '/assets/images/logos/logo-clients/santander.svg',
        type: 'image',
        alt: 'logo santander',
      },
      {
        url: '/assets/images/logos/logo-clients/orange-bank.svg',
        type: 'image',
        alt: 'logo orange bank',
      },
      {
        url: '/assets/images/logos/logo-clients/securitas.svg',
        type: 'image',
        alt: 'logo securitas',
      },
      {
        url: '/assets/images/logos/logo-clients/repsol.svg',
        type: 'image',
        alt: 'logo repsol',
      },
      {
        url: '/assets/images/logos/logo-clients/pelayo.svg',
        type: 'image',
        alt: 'logo pelayo',
      },
      {
        url: '/assets/images/logos/logo-clients/universia.svg',
        type: 'image',
        alt: 'logo universia',
      },
      {
        url: '/assets/images/logos/logo-clients/endesa.webp',
        type: 'image',
        alt: 'logo endesa',
      },
      {
        url: '/assets/images/logos/logo-clients/bankia.svg',
        type: 'image',
        alt: 'logo bankia',
      },
      {
        url: '/assets/images/logos/logo-clients/cecabank.svg',
        type: 'image',
        alt: 'logo cecabank',
      },
      {
        url: '/assets/images/logos/logo-clients/spotlight.webp',
        type: 'image',
        alt: 'logo spotlight',
      },
      {
        url: '/assets/images/logos/logo-clients/belcorp.svg',
        type: 'image',
        alt: 'logo belcorp',
      },
      {
        url: '/assets/images/logos/logo-clients/lefebvre.svg',
        type: 'image',
        alt: 'logo lefebvre',
      },
      {
        url: '/assets/images/logos/logo-clients/oh.svg',
        type: 'image',
        alt: 'logo oh',
      },
      {
        url: '/assets/images/logos/logo-clients/billionhands.svg',
        type: 'image',
        alt: 'logo billionhands',
      },
      {
        url: '/assets/images/logos/logo-clients/azteca.svg',
        type: 'image',
        alt: 'logo azteca',
      },
      {
        url: '/assets/images/logos/logo-clients/orange-x.webp',
        type: 'image',
        alt: 'logo orange-x',
      },
      {
        url: '/assets/images/logos/logo-clients/european-union.svg',
        type: 'image',
        alt: 'logo union europea',
      },
      {
        url: '/assets/images/logos/logo-clients/cepsa.svg',
        type: 'image',
        alt: 'logo cepsa',
      },
      {
        url: '/assets/images/logos/logo-clients/pagos-fx.webp',
        type: 'image',
        alt: 'logo pagos-fx',
      },
      {
        url: '/assets/images/logos/logo-clients/wegow.svg',
        type: 'image',
        alt: 'logo wegow',
      },
      {
        url: '/assets/images/logos/logo-clients/galderma.svg',
        type: 'image',
        alt: 'logo galderma',
      },
      {
        url: '/assets/images/logos/logo-clients/deceye.svg',
        type: 'image',
        alt: 'logo deceye',
      },
      {
        url: '/assets/images/logos/logo-clients/agile-spain.webp',
        type: 'image',
        alt: 'logo agile spain',
      },
      {
        url: '/assets/images/logos/logo-clients/generali.webp',
        type: 'image',
        alt: 'logo generali',
      },
      {
        url: '/assets/images/logos/logo-clients/idipaz.webp',
        type: 'image',
        alt: 'logo idipaz',
      },
      {
        url: '/assets/images/logos/logo-clients/mm.webp',
        type: 'image',
        alt: 'logo mm',
      },
      {
        url: '/assets/images/logos/logo-clients/rubio.webp',
        type: 'image',
        alt: 'logo rubio',
      },
      {
        url: '/assets/images/logos/logo-clients/BCP_Peru_logo.png',
        type: 'image',
        alt: 'logo BCP Peru',
      },
    ],
  },
};
